import React from "react";
import Card from "../../components/page/Card.jsx";
import TabList from "../../components/Tab/TabList.jsx";
import TabButton from "../../components/Tab/TabButton.jsx";
import TabContent from "../../components/Tab/TabContent.jsx";
import ErrorSwal from "../../components/Swal/errorSwal.jsx";
import ClienteTab from "./EmissorInvoice/ClienteTab.jsx";
import ServicoTab from "./EmissorInvoice/ServicoTab.jsx";
import InformacoesTab from "./EmissorInvoice/InformacoesTab.jsx";
import DadosInvoice from "./EmissorInvoice/DadosInvoice.jsx";
import NovoClienteModal from "../notasFiscais/EmissorNFSe/NovoClienteModal.jsx";
import ClienteApiClient from "../../api/cliente.js";
import useApi from "../../hooks/useApi.js";
import { AppContext } from "../../contexts/AppContext.jsx";
import EmpresaApiClient from "../../api/empresa.js";
import OptionsSwal from "../../components/Swal/optionsSwal.jsx";
import { Cores } from "../../constants/Cores.js";
import Validation from "../../helpers/Validation.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import InvoiceApiClient from "../../api/invoices.js";

function EmissorInvoice() {
  const [values, setValues] = React.useState({
    valorTotal: "",
    quantidade: "",
    valorUnitario: "",
    descricaoServico: "",
    data: "",
    metodoPagamento: [],
    desconto: "",
  });
  const [tabAtual, setTabAtual] = React.useState(0);
  const [invoiceData, setInvoiceData] = React.useState([]);
  const [clienteValues, setClienteValues] = React.useState({});
  const [clienteTab, setClienteTab] = React.useState(0);
  const [novoClienteModal, setNovoClienteModal] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  const [clientes, setClientes] = React.useState([]);
  const [disabled, setDisabled] = React.useState(false);
  const { session, baseUrl } = React.useContext(AppContext);

  const getClienteCb = React.useCallback(() => {
    return ClienteApiClient.getCliente(
      session.empresa.replace(/E/gi, ""),
      values.cliente
    );
  }, [session.empresa, values.cliente]);

  const { request: getClientes, data: clientesResponse } = useApi(
    ClienteApiClient.listClientes
  );
  const { request: getCliente, data: clienteResponse } = useApi(getClienteCb);
  const { request: getEmpresaEndereco, data: empresaEnderecoResponse } = useApi(
    EmpresaApiClient.getEndereco
  );
  const postInvoiceApi = useApi(InvoiceApiClient.postInvoice);
  const putInvoiceApi = useApi(InvoiceApiClient.putInvoice);
  //Busca clientes ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getClientes(session.empresa.replace(/E/gi, ""));
  }, [getClientes, session.empresa]);

  //Define estado clientes ao receber clientes
  React.useEffect(() => {
    if (clientesResponse) {
      const novosClientes = clientesResponse.filter(
        (cliente) => !clientes.some((c) => c.uid === cliente.uid)
      );

      setClientes((prevClientes) => [...prevClientes, ...novosClientes]);
    }
  }, [clientes, clientesResponse]);

  //Busca cliente ao alterar valor do campo
  React.useEffect(() => {
    if (values.cliente && session.empresa) getCliente();
  }, [getCliente, session.empresa, values.cliente]);

  //Define cliente nos dados do invoice ao receber cliente
  React.useEffect(() => {
    if (!clienteResponse) return;
    const {
      razao_social,
      logradouro,
      numero,
      complemento,
      bairro,
      cidade,
      uf,
      cep,
    } = clienteResponse;
    setInvoiceData((prevDados) => ({
      ...prevDados,
      razao_social,
      logradouro,
      numero,
      complemento,
      bairro,
      cidade,
      uf,
      cep,
    }));
  }, [clienteResponse, setInvoiceData]);

  React.useEffect(() => {
    if (session.empresa) getEmpresaEndereco(session.empresa.replace(/E/gi, ""));
  }, [getEmpresaEndereco, session.empresa]);

  //Define estado endereço
  React.useEffect(() => {
    if (empresaEnderecoResponse) {
      setInvoiceData((prevData) => ({
        ...prevData,

        enderecoEmpresa: empresaEnderecoResponse.endereço,
        numeroEmpresa: empresaEnderecoResponse.numero,
        complEmpresa: empresaEnderecoResponse.compl,
        bairroEmpresa: empresaEnderecoResponse.bairro,
        cidadeEmpresa: empresaEnderecoResponse.cidade,
        cepEmpresa: empresaEnderecoResponse.cep,
        ufEmpresa: empresaEnderecoResponse.uf,
        razao: session.razao,
      }));
    }
  }, [empresaEnderecoResponse, session.razao]);

  const checkClientesTab = () => {
    if (!values.cliente) {
      ErrorSwal({
        title:
          "É necessário selecionar um cliente para ir para a próxima etapa.",
      });
      return false;
    }
    return true;
  };

  const checkServicoTab = () => {
    if (!invoiceData.itens || invoiceData.itens.length === 0) {
      ErrorSwal({
        title: "Não há serviços adicionados.",
      });
      return false;
    }

    return true;
  };

  const checkInformacoesTab = () => {
    if (!values.data) {
      ErrorSwal({
        title: "Selecione uma data de referência.",
      });
      return false;
    } else if (!values.metodoPagamento || values.metodoPagamento.length === 0) {
      ErrorSwal({
        title: "Defina um método de pagamento.",
      });
      return false;
    } else if (!invoiceData.itens || invoiceData.itens.length === 0) {
      ErrorSwal({
        title: "Não há serviços adicionados.",
      });
      return false;
    } else if (
      (invoiceData?.itens
        ? invoiceData.itens.reduce(
            (total, invoice) => total + (invoice.valorTotal || 0),
            0
          )
        : 0) <= values?.desconto
    ) {
      ErrorSwal({
        title: "O valor do desconto não pode ser maior ou igual ao sub total.",
      });
      return false;
    }
    return true;
  };

  const salvaServico = () => {
    if (values.descricaoServico.length < 5 || !values.descricaoServico.trim()) {
      return ErrorSwal({
        title: "Descrição deve possuir mais de 5 caracteres.",
      });
    } else if (!values.valorUnitario || values.valorUnitario < 1) {
      return ErrorSwal({
        title: "Valor do serviço deve ser superior a R$1,00.",
      });
    } else if (!values.quantidade || values.quantidade < 1) {
      return ErrorSwal({
        title: "Quantidade não pode ser menor do que 1.",
      });
    }

    setInvoiceData({
      ...invoiceData,
      itens: [
        ...(invoiceData.itens || []),
        {
          descricao: values.descricaoServico,
          quantidade: values.quantidade,
          valorUnitario: parseFloat(values.valorUnitario).toFixed(2),
          valorTotal: parseFloat(
            values.valorUnitario * values.quantidade
          ).toFixed(2),
        },
      ],
    });

    return true;
  };

  const excluirItem = (index) => {
    console.log("Índice do item a ser excluído:", index);
    const novosItens = [...invoiceData.itens];
    novosItens.splice(index, 1);
    setInvoiceData({
      ...invoiceData,
      itens: novosItens,
    });
  };

  const togNovoClienteModal = React.useCallback(() => {
    setClienteValues({});
    setClienteTab(0);
    setNovoClienteModal(true);
    setSent(false);
  }, []);

  const resetaClientes = () => {
    setValues((prevValues) => ({ ...prevValues, cliente: "" }));
    setInvoiceData((prevValues) => ({
      ...prevValues,
      razao_social: "",
      cnpj: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      cep: "",
      uf: "",
      codigoCidade: "",
    }));
    setClientes([]);
  };

  const gerarPDF = async () => {
    const card = document.getElementById("invoice-card"); // Defina um ID no Card
    let pdfBlob;
    const formData = new FormData();

    if (!card) {
      console.error("Elemento não encontrado!");
      setDisabled(false);
      return null;
    }

    try {
      const canvas = await html2canvas(card, { scale: 2 }); // Converte o card para uma imagem usando html2canvas
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4"); // Cria um novo PDF no formato A4
      const imgWidth = 190; // Largura máxima da imagem no PDF (190mm para A4)
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Mantém a proporção
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight); // Adiciona a imagem ao PDF
      pdfBlob = pdf.output("blob", { type: "application/pdf" }); // Converte o PDF para Blob
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      setDisabled(false);
      return null;
    }

    formData.append("arquivo", pdfBlob, `invoice_${invoiceData.idInvoice}.pdf`);
    formData.append("invoiceData", JSON.stringify(invoiceData));

    const response = await putInvoiceApi.request(
      session?.empresa.replace(/E/gi, ""),
      invoiceData.uidInvoice,
      formData
    );
    setDisabled(false);

    if (!response) return;
    setValues({
      valorTotal: "",
      quantidade: "",
      valorUnitario: "",
      descricaoServico: "",
      data: "",
      metodoPagamento: [],
      desconto: "",
    });
    setInvoiceData([]);
    setTabAtual(0);
    OptionsSwal({
      title: "Invoice emitido",
      icon: "question",
      text: 'Deseja emitir um novo invoice ou  ir para o "Gerenciador de invoices"?',
      confirmButtonText: "Novo invoice",
      denyButtonText: "Gerenciar invoices",
      confirmButtonColor: Cores.common.primary,
      denyButtonColor: Cores.buttons.verdeConfirm,
      reverseButtons: true,
    }).then((result) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (result.isConfirmed) {
        window.location.reload();
      } else if (result.isDenied || result.isDismissed) {
        window.location.href = baseUrl + "invoices/Invoices";
      }
    });
  };

  React.useEffect(() => {
    if (invoiceData.idInvoice) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      gerarPDF();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceData.idInvoice]);

  const salvarInformacoes = async () => {
    if (disabled) return;

    const formData = new FormData();

    formData.append("tomador", invoiceData?.razao_social);
    formData.append(
      "valor",
      invoiceData?.itens
        ? invoiceData.itens.reduce(
            (total, invoice) => total + (parseFloat(invoice.valorTotal) || 0),
            0
          ) - (values?.desconto || 0)
        : 0
    );
    formData.append("data_emissao", values?.data);

    if (Validation.verificarForm(formData))
      return {
        text: "Favor preencher todos os dados obrigatórios.",
      };

    const response = await postInvoiceApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );

    if (!response) return;
    setDisabled(true);
    setInvoiceData({
      ...invoiceData,
      data: values.data,
      metodoPagamento: values.metodoPagamento,
      desconto: values.desconto,
      idInvoice: response.id,
      uidInvoice: response.uid,
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-7 mb-1">
          <Card margin={0}>
            <TabList>
              <TabButton href="clienteTab" ativo={true} disabled={true}>
                Cliente
              </TabButton>
              <TabButton href="servicoTab" disabled={true}>
                Serviços
              </TabButton>
              <TabButton href="informacoesTab" disabled={true}>
                Informações
              </TabButton>
            </TabList>
            <TabContent padding={0}>
              <ClienteTab
                tabAtualHook={{ tabAtual, setTabAtual }}
                clientesHook={{ clientes, setClientes }}
                valuesHook={{ values, setValues }}
                checkClientesTab={checkClientesTab}
                togNovoClienteModal={togNovoClienteModal}
              />
              <ServicoTab
                tabAtualHook={{ tabAtual, setTabAtual }}
                checkServicoTab={checkServicoTab}
                valuesHook={{ values, setValues }}
                salvaServico={salvaServico}
              />
              <InformacoesTab
                tabAtualHook={{ tabAtual, setTabAtual }}
                valuesHook={{ values, setValues }}
                checkInformacoesTab={checkInformacoesTab}
                salvarInformacoes={salvarInformacoes}
              />
            </TabContent>
          </Card>
        </div>
        <div
          className={`col-lg-${invoiceData?.idInvoice ? 12 : 5}`}
          style={{ minWidth: invoiceData?.idInvoice ? "1600px" : "unset" }}
        >
          <Card id="invoice-card" margin={0}>
            <DadosInvoice
              values={values}
              invoiceData={invoiceData}
              excluirItem={excluirItem}
            />
          </Card>
        </div>
      </div>
      <NovoClienteModal
        modalHook={{ novoClienteModal, setNovoClienteModal }}
        valuesHook={{ clienteValues, setClienteValues }}
        clienteTabHook={{ clienteTab, setClienteTab }}
        buscaClientes={getClientes}
        resetaClientes={resetaClientes}
        sentHook={{ sent, setSent }}
      />
    </>
  );
}

export default EmissorInvoice;
